import { errorClassificationLookup, rejectionTypeToPolicyTypeMap } from '@ourbranch/lookups';

// BYPASS_ALERT and DISMISSIBLE_REJECTION only block navigation when relevant to the selected policy type.
// Other alert types (plain ALERT) always block
export function shouldAlertBlockNavigation(alert, policyType) {
  const alertType = errorClassificationLookup[Number(alert.code)];
  if (alertType === 'BYPASS_ALERT' || alertType === 'DISMISSIBLE_REJECTION') {
    return rejectionTypeToPolicyTypeMap[alert.type]?.includes(policyType) ?? false;
  }
  return true;
}
